var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"ace-editor"},[_c('editor',{attrs:{"width":"100%","lang":"scss","theme":"monokai","height":"200px"},on:{"init":_vm.editorInit},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }